/*
 * ManageUsers Messages
 *
 * This contains all the text for the ManageUsers component.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  firstName: {
    id: 'registerForm_firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'registerForm_lastName',
    defaultMessage: 'Last Name',
  },
  company: {
    id: 'pinTask_company',
    defaultMessage: 'Company',
  },
  companyName: {
    id: 'pinTask_company',
    defaultMessage: 'Company',
  },
  jobTitle: {
    id: 'userSettings_job',
    defaultMessage: 'Job title',
  },
  internalId: {
    id: 'personas_internalID',
    defaultMessage: 'Internal Id',
  },
  email: {
    id: 'registerForm_email',
    defaultMessage: 'Email',
  },
  phone: {
    id: 'userSettings_phone',
    defaultMessage: 'Phone',
  },
  fax: {
    id: 'personas_fax',
    defaultMessage: 'Fax',
  },
  street: {
    id: 'projectSettings_street',
    defaultMessage: 'Street',
  },
  zip: {
    id: 'projectSettings_postcode',
    defaultMessage: 'ZIP',
  },
  city: {
    id: 'projectSettings_city',
    defaultMessage: 'City',
  },
  countryCode: {
    id: 'registerForm_country',
    defaultMessage: 'Country',
  },
  licenseTypeNone: {
    id: 'personas_licenseTypeNone',
    defaultMessage: 'None',
  },
  licenseTypeMaster: {
    id: 'personas_licenseTypeMaster',
    defaultMessage: 'Master',
  },
  licenseTypeMulti: {
    id: 'personas_licenseTypeMulti',
    defaultMessage: 'Multi',
  },
  licenseTypeCombo: {
    id: 'personas_licenseTypeCombo',
    defaultMessage: 'Combo',
  },
  licenseTypePocket: {
    id: 'personas_licenseTypePocket',
    defaultMessage: 'Pocket',
  },
  licenseTypeTest: {
    id: 'personas_licenseTypeTest',
    defaultMessage: 'Test',
  },
  licenseTypeCanceled: {
    id: 'personas_licenseTypeCanceled',
    defaultMessage: 'Canceled',
  },
  paymentPlanOneTime: {
    id: 'personas_paymentTypeOneTime',
    defaultMessage: 'One time',
  },
  paymentPlanMonthly: {
    id: 'personas_paymentTypeMonthly',
    defaultMessage: 'Monthly',
  },
  paymentPlanAnnually: {
    id: 'personas_paymentTypeAnnually',
    defaultMessage: 'Annually',
  },
  fieldAttributeFirstName: {
    id: 'registerForm_firstName',
    defaultMessage: 'FirstName',
  },
  fieldAttributeLastName: {
    id: 'registerForm_lastName',
    defaultMessage: 'LastName',
  },
  fieldAttributeName: {
    id: 'name',
    defaultMessage: 'Name',
  },
  fieldAttributePhone: {
    id: 'userSettings_phone',
    defaultMessage: 'Phone',
  },
  fieldAttributeFax: {
    id: 'personas_fax',
    defaultMessage: 'Fax',
  },
  fieldAttributeJobTitle: {
    id: 'userSettings_job',
    defaultMessage: 'JobTitle',
  },
  fieldAttributeInternalId: {
    id: 'personas_internalID',
    defaultMessage: 'InternalId',
  },
  fieldAttributeEmail: {
    id: 'registerForm_email',
    defaultMessage: 'Email',
  },
  fieldAttributeUsername: {
    id: 'personas_username',
    defaultMessage: 'Username',
  },
  fieldAttributeStreet: {
    id: 'projectSettings_street',
    defaultMessage: 'Street',
  },
  fieldAttributeZip: {
    id: 'projectSettings_postcode',
    defaultMessage: 'Zip',
  },
  fieldAttributeCity: {
    id: 'projectSettings_city',
    defaultMessage: 'City',
  },
  fieldAttributeActive: {
    id: 'active',
    defaultMessage: 'Active',
  },
  fieldAttributeIgnored: {
    id: 'personas_ignored',
    defaultMessage: 'Ignored',
  },
  fieldAttributeIgnore: {
    id: 'personas_ignored',
    defaultMessage: 'Ignore',
  },
  fieldAttributeCompanyName: {
    id: 'personas_importFieldAttributeCompanyName',
    defaultMessage: 'Company name',
  },
  fieldAttributeUnknown: {
    id: 'personas_fieldAttributeUnknown',
    defaultMessage: 'Unknown',
  },
  userLicenseTypeFull: {
    id: 'personas_userLicenseTypeFull',
    defaultMessage: 'full',
  },
  userLicenseTypeMobileOnly: {
    id: 'personas_userLicenseTypeMobileOnly',
    defaultMessage: 'mobile only',
  },
  userLicenseTypeNone: {
    id: 'personas_userLicenseTypeBuy',
    defaultMessage: 'buy',
  },
  userLicenseStatePending: {
    id: 'personas_userLicenseStatePending',
    defaultMessage: 'Pending',
  },
  userLicenseStateInactive: {
    id: 'personas_userLicenseStateInactive',
    defaultMessage: 'Inactive',
  },
  userLicenseStateActive: {
    id: 'personas_userLicenseStateActive',
    defaultMessage: 'Active',
  },
  paymentTypeDirectDebit: {
    id: 'upgradePlan_paymentTypeDirectDebit',
    defaultMessage: 'Direct debit',
  },
  paymentTypeCreditCard: {
    id: 'upgradePlan_paymentTypeCreditCard',
    defaultMessage: 'Credit card',
  },
  paymentTypeOther: {
    id: 'upgradePlan_paymentTypeOther',
    defaultMessage: 'Other',
  },
  roleDescriptionPowerUser: {
    id: 'personas_roleDescriptionPowerUser',
    defaultMessage: 'Manage project members',
  },
  roleDescriptionPowerUser2: {
    id: 'personas_roleDescriptionPowerUser2',
    defaultMessage: 'Set content active/inactive',
  },
  roleDescriptionPowerUser3: {
    id: 'personas_roleDescriptionPowerUser3',
    defaultMessage: 'View, create & comment',
  },
  roleDescriptionPowerUser4: {
    id: 'personas_roleDescriptionPowerUser4',
    defaultMessage: 'Edit everything',
  },
  roleDescriptionAssistant: {
    id: 'personas_roleDescriptionAssistant',
    defaultMessage: 'View, create & comment',
  },
  roleDescriptionAssistant2: {
    id: 'personas_roleDescriptionAssistant2',
    defaultMessage: 'Edit own content only',
  },
  roleDescriptionViewer: {
    id: 'personas_roleDescriptionViewer',
    defaultMessage: 'View all pins & comment',
  },
  roleDescriptionViewer2: {
    id: 'personas_roleDescriptionViewer2',
    defaultMessage: 'No content creation',
  },
  roleDescriptionExternalVisitor: {
    id: 'personas_roleDescriptionExternalVisitor',
    defaultMessage: 'View own pins & comment',
  },
  roleDescriptionExternalVisitor2: {
    id: 'personas_roleDescriptionExternalVisitor2',
    defaultMessage: 'Create pins & pin media',
  },
  roleDescriptionSubContractor: {
    id: 'personas_roleDescriptionSubContractor',
    defaultMessage: 'See, fulfill and comment assigned tasks',
  },
  roleDescriptionNone: {
    id: 'personas_roleDescriptionNone',
    defaultMessage: 'User is set inactive in this project',
  },
  roleLabelPowerUser: {
    id: 'personas_roleLabelPowerUser',
    defaultMessage: 'Administrator',
  },
  roleLabelAssistant: {
    id: 'personas_roleLabelAssistant',
    defaultMessage: 'Assistant',
  },
  roleLabelViewer: {
    id: 'personas_roleLabelViewer',
    defaultMessage: 'Viewer',
  },
  roleLabelExternalVisitor: {
    id: 'personas_roleLabelExternalVisitor',
    defaultMessage: 'Visitor',
  },
  roleLabelSubContractor: {
    id: 'personas_roleLabelSubContractor',
    defaultMessage: 'Sub contractor',
  },
})
